import { TRAFFIC_SOURCES } from "./constants";
import { useTrafficSourceTabsContext } from "./TrafficSourceTabsContext";

export const useSelectedTrafficSource = () => {
    const [selectedIndex] = useTrafficSourceTabsContext();

    return TRAFFIC_SOURCES[selectedIndex];
};
